import { render, staticRenderFns } from "./add-friend-search.vue?vue&type=template&id=28dcb6f3&scoped=true&"
import script from "./add-friend-search.vue?vue&type=script&lang=js&"
export * from "./add-friend-search.vue?vue&type=script&lang=js&"
import style0 from "./add-friend-search.vue?vue&type=style&index=0&id=28dcb6f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcb6f3",
  null
  
)

export default component.exports